import { isEmoji } from '../emoji'
import { googleMaterialSymbolGlyphMap } from './map'
import { isCustomIconId, isLegacyIcon, type LegacyIcon } from '@terros/common'

export type MaterialSymbolType = keyof typeof googleMaterialSymbolGlyphMap
export const availableMaterialSymbols = Object.keys(googleMaterialSymbolGlyphMap) as MaterialSymbolType[]
export const isMaterialSymbol = (icon?: string): icon is MaterialSymbolType => {
  return Boolean(googleMaterialSymbolGlyphMap[icon as MaterialSymbolType])
}

export const isValidIcon = (icon: string): boolean => {
  if (isLegacyIcon(icon)) return true
  if (isEmoji(icon)) return true
  if (isMaterialSymbol(icon)) return true
  if (isCustomIconId(icon)) return true
  return false
}

const legacyToMaterialMap: Map<LegacyIcon, MaterialSymbolType> = new Map([
  ['clockcircle', 'schedule'],
  ['comment-dots', 'comment'],
  ['door-closed', 'door_front'],
  ['flag', 'flag'],
  ['home-floor-1', 'home'],
  ['home-floor-2', 'home'],
  ['home-floor-3', 'home'],
  ['hour-glass', 'hourglass_bottom'],
  ['not-interested', 'block'],
  ['plus', 'add'],
])

export const mapLegacyToMaterialIcon = (legacyIcon: string): MaterialSymbolType | undefined => {
  if (isLegacyIcon(legacyIcon)) {
    return legacyToMaterialMap.get(legacyIcon)
  }
}
